import { render } from "./AYPResultPage.vue?vue&type=template&id=09d59cae&scoped=true"
import script from "./AYPResultPage.vue?vue&type=script&lang=js"
export * from "./AYPResultPage.vue?vue&type=script&lang=js"

import "./AYPResultPage.vue?vue&type=style&index=0&id=09d59cae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d59cae"]])

export default __exports__